import { GenericLookupType } from 'src/core/decorators/generic-lookup/generic-lookup-type.decorator';
import { GenericLookup } from 'src/core/decorators/generic-lookup/generic-lookup.decorator';

@GenericLookupType({
  code: 'Feedback.Source',
})
export class FeedbackSource {
  @GenericLookup({
    code: 'Feedback.Source.Conversation',
  })
  static conversation: number;

  @GenericLookup({
    code: 'Feedback.Source.Coaching',
  })
  static coaching: number;
}
